export const AbtType = 'ABT'
export const AssistType = 'ASSIST'
export const AbtActivatingType = 'ABT_ACTIVATING'

export type Type = AbtType | AssistType | AbtActivatingType

export type AccountType = {
  type: Type
}



// WEBPACK FOOTER //
// ./src/types/customer-account-type.js